import { render, staticRenderFns } from "./OrganisationSharingManage.vue?vue&type=template&id=6d0f158a"
import script from "./OrganisationSharingManage.vue?vue&type=script&lang=js"
export * from "./OrganisationSharingManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports